module.exports = __webpack_public_path__ + "assets/de3c24ec634054b11bc7bea2df6b6835.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/mystery/AfterFlameAdd.mp3
 ** module id = 346
 ** module chunks = 0
 **/